

 <app-header-helena bannerImage="horizon-sprayer.png"></app-header-helena>

<div *ngIf="showIntroduction" id="introduction">
  <p>Tankmix is a service outlining the mixability of Ele-Max products with many plant protection products.</p>
  <p>Ele-Max is a line of high quality micronutrients and foliar nutritional blends formulated specifically for plant nutrition.
    They are manufactured from high-purity raw ingredients, with balanced crop nutrition and crop safety as the primary concern.
    The Ele-Max line consists of high-analysis products available in liquid concentrates (LC) and liquid flowables (FL).</p>

  <p>
    Access is freely available to everyone,  and allows for better planning of spray programmes and
    spraying opportunities with most of the Ele-Max range. Each tank mix test is carried out under controlled conditions in our product
    development laboratories following BS EN ISO 9001:2000 guidelines and represents a fair measure of the performance of each mixture made.
    Of course, there are many variables in making tank mixes under field conditions that can influence the mixability of any mixture made
    and so the Tankmix Guide is just that, a guide, and not a guarantee of either physical or biological compatibility.
  </p>

</div>

<button class="btn" (click)="toggleIntroduction()" >Show/Hide Introduction</button>
<div *ngIf="!results">
  <h2  >Search</h2>
  <form *ngIf="!searching" name="searchForm" [formGroup]="searchForm">
    <div class="sideBySide">
      <div > 

        <div  class="form-group">
          <label for="yaraChemicalId" >Choose a Product (optional)</label>
        <app-nameid-typeahead [items]="yaraProductChoices" id="yaraChemicalId" 
        formControlName="yaraChemicalId" 
        ></app-nameid-typeahead>
        <small class="form-text textmuted"> </small>
        </div>
      </div>

      <div  >
        <div class="form-group">
          <label 
          >Choose an agrochemical (optional)
        </label>
        <app-nameid-typeahead [items]="agrochemicalChoices" id="agrochemicalCode" 
        formControlName="agrochemicalCode" 
        ></app-nameid-typeahead>
        <small class="form-text textmuted"> </small>
        </div>
        <div class="form-group">
          <label for="activeIngredientDropDown" >Choose an Active Ingredient (optional)</label>
        <app-nameid-typeahead [items]="activeIngredientChoices"formControlName="activeIngredientCode"
         ></app-nameid-typeahead>
        <small class="form-text textmuted"> </small>
        </div>
      </div>
    </div>
    <div >
      <button class="btn-success " (click)="performSearch()">Search for Tankmix Results</button>
      <button class="btn" (click)="resetSearch()">Reset</button>
    </div>
  </form>

  <!-- searching -->
  <div *ngIf="searching">
    Searching ......
  </div>
</div>

<!-- results-->
<div *ngIf="results">
  <h3>Search Results</h3>  <app-units-chooser></app-units-chooser>
  <div *ngIf="!results.length" class="alert alert-info">
    <p>No Tankmix results were found.</p>
    <p>You may adjust your criteria, or you can ask one of our chemist to carry out a new test for you.</p>

    <a routerLink="/request"> <button class="btn">Request Chemical Analysis</button></a>
  </div>

  <div *ngIf="results.length">
    <table class="table-yara">
      <thead>
        <tr>
          <th>Date Tested</th>
        
          <th>Water Volume</th>
       
          <th>Products</th>
          <th>Result</th>
          <th>Download Report</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tankmix of results">
          <td>{{ tankmix.dateOfTest | date }}</td>
          
          <td>{{ convertedWaterRate(tankmix.waterRate)  | number:'1.2-2'}}</td>
         
          <td>
            <table class="ingredientTable">
              <thead>
                <tr>
                  <th class='numberColumn'>Order</th>
                  <th class='numberColumn'>Rate</th>
                  <th class='manufacturerColumn'>Manufacturer</th>
                  <th>Name</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ingredient of tankmix.ingredients">
                  <td>{{ ingredient.orderOfAddition }}</td>
                  <td><span *ngIf="ingredient.form!='P'">{{ convertedAppRate(ingredient.rate) | number:'1.2-2'}}</span> <span *ngIf="ingredient.form=='P'">{{convertPowderUnits(ingredient.rate)}}</span> 
                  </td>
                  <td>{{ ingredient.manufacturer }}</td>
                  <td>
                    <span *ngIf="!ingredient.products">{{ ingredient.name }}</span>
                    <div *ngIf="ingredient.products">
                      <span *ngFor="let product of ingredient.products">{{ product }}, </span>
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
            <span *ngIf="tankmix.observations">{{ tankmix.obserations }}</span>
          </td>
          <td>
          
            <app-result-icon [value]="tankmix.result!='NC'"></app-result-icon>
         </td>
         <td routerLink="testResult/{{tankmix.tankmixId}}/US" i18n-title="@@Download Report"
         title="Download report">
          
           
         <app-pdf-icon></app-pdf-icon>
       </td>
        </tr>
      </tbody>
    </table>
  </div>
  <button class="btn" (click)="searchAgain()">Adjust Search Criteria</button>
</div>
